import fetchMerchandiseByIds from 'actions/merchandise/fetchMerchandiseByIds'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useStableObjectReference from 'hooks/useStableObjectReference'
import { isNonNullable } from 'lib/array/arrayUtils'
import { useEffect, useMemo } from 'react'

interface Options {
  disabled?: boolean;
}

type ReturnType = [
  Array<App.MerchandiseOffer>,
  boolean,
  any
]

function useMerchandiseOffers(offerIds: Array<string>, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()
  const merchandiseOffers = useAppSelector(state => state.merchandise.merchandise)
  const fetchingMerchandise = useAppSelector(state => state.merchandise.fetchingMerchandise)
  const merchandiseErrors = useAppSelector(state => state.merchandise.merchandiseErrors)

  const stableOfferIds = useStableObjectReference(offerIds)

  useEffect(() => {
    if (!options.disabled) {
      dispatch(fetchMerchandiseByIds(stableOfferIds))
    }
  }, [dispatch, stableOfferIds, options.disabled])

  const offers = useMemo(() => {
    return offerIds.map(id => merchandiseOffers[id]).filter(isNonNullable)
  }, [merchandiseOffers, offerIds])

  return [
    offers,
    offerIds.some(id => fetchingMerchandise[id]),
    offerIds.find(id => merchandiseErrors[id])
  ]
}

export default useMerchandiseOffers
